import { gql } from '@common/hooks';

export const OrganizationUnitsCreationMutation = gql`
  mutation OrganizationUnitsCreationMutation(
    $input: [CreateOrganizationUnitInput!]!
  ) {
    createOrganizationUnits(input: $input) {
      organizationUnits {
        id
      }
    }
  }
`;

export type OrganizationUnitsCreationMutationResponse = {
  createOrganizationUnits: {
    organizationUnits: {
      id: string;
    }[];
  };
};

export type OrganizationUnitsCreationMutationVariables = {
  input: {
    name: string;
    costCenter: string;
    clinicalUnitId: string;
    organizationBusinessId?: string;
  }[];
};
